<user-navigation></user-navigation>

<div class="container-fluid">
  <div id="top"></div>
  <div class="row no-gutter">
    <div class="col-md-12 col-lg-4" style="margin-top: 10vh!important">
      <div class="default-box long-form d-flex align-items-center" style="min-height: 0vh;">
        <div class="container">
          <div class="row">
            <div class="col-md-12">
              <div *ngIf="user">
                <img *ngIf="user?.avatar; else noAvatar" [src]="user?.avatar"
                class="mb-md-4 mb-4 rounded-circle avatar-big">
                <ng-template #noAvatar>
                  <img class="mb-md-4 mb-4 rounded-circle avatar-big" src="../../../../assets/images/avatars/default_profile@2x.png">
                </ng-template>
                <h3 class="display-4 box-title">{{ fullname }}</h3>
              </div>
              <ul class="mt-5 mt-md-5">
                <li *ngFor="let menu of menus" [routerLink]="menu?.link">
                  <a>{{ menu?.text }} <span><i class="fa fa-angle-right"></i></span></a>
                </li>
                <li><a (click)="authService.logout()" class="text-danger">Log Out </a><span><i
                      class="fa fa-angle-right"></i></span></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-8 d-none d-lg-flex default-box bg-image-user"></div>
  </div>

  <!-- Modal Loader -->
  <modal-loader [modalText]="modalText"></modal-loader>

</div>

<footer-main></footer-main>
